const config = {
  api: {
    baseURL: process.env.REACT_APP_API_URL || 'https://forgevault.onrender.com',
    timeout: parseInt(process.env.REACT_APP_API_TIMEOUT) || 120000,
    retryAttempts: parseInt(process.env.REACT_APP_API_RETRY) || 3,
    retryDelay: 1000,
  },

  google: {
    clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID || '',
  },

  emailjs: {
    serviceId: process.env.REACT_APP_EMAILJS_SERVICE_ID || '',
    templateId: process.env.REACT_APP_EMAILJS_TEMPLATE_ID || '',
    publicKey: process.env.REACT_APP_EMAILJS_PUBLIC_KEY || '',
  },

  app: {
    name: 'ForgeVault',
    version: '1.0.0',
    environment: process.env.NODE_ENV || 'development',
    enableAnalytics: process.env.REACT_APP_ENABLE_ANALYTICS === 'true',
    enableLogging: process.env.NODE_ENV === 'development',
  },

  features: {
    enableSchemaValidation: true,
    enableVariables: true,
    enableDownload: true,
    enableCopy: true,
    maxVariables: 20,
  },

  ui: {
    toastDuration: 5000,
    animationDuration: 300,
    debounceDelay: 500,
  },

  validation: {
    description: {
      minLength: 10,
      maxLength: 2000,
    },
    useCase: {
      minLength: 10,
      maxLength: 1000,
    },
    schema: {
      maxLength: 10000,
    },
    variableName: {
      pattern: /^[a-zA-Z_][a-zA-Z0-9_]*$/,
      maxLength: 50,
    },
    variableDescription: {
      maxLength: 200,
    },
  },
};

export default config;

